import React from 'react';
import Other from '../Common/Other';
import { OTHER_VALUE } from '../constants';
import QuestionLabel from '../QuestionLabel';
import CheckboxOption from './CheckboxOption';

type Props = {
  handleEditResponse: $TSFixMeFunction;
  onChange: $TSFixMeFunction;
  question: $TSFixMe;
  value?: {
    freeform?: string;
    keys?: string[];
  };
};

const Checkbox = ({ handleEditResponse, question, onChange, value }: Props) => {
  value = value ? value : {};

  const otherOptionLabel = question.properties.otherLabel || 'Other';

  const selectedValues = value.keys ? value.keys : [];
  const otherTextValue = value.freeform ? value.freeform : '';

  const handleCheckedInput = async (
    checked: $TSFixMe,
    inputValue: $TSFixMe,
  ) => {
    const updatedValues = {};

    if (checked) {
      (updatedValues as $TSFixMe).keys = [...selectedValues, inputValue];
    } else {
      (updatedValues as $TSFixMe).keys = selectedValues.filter(
        (i) => i !== inputValue,
      );
    }

    if ((updatedValues as $TSFixMe).keys.includes(OTHER_VALUE)) {
      (updatedValues as $TSFixMe).freeform = otherTextValue;
    }

    await onChange(updatedValues);
    handleEditResponse();
  };

  const handleOtherTextChange = (text: $TSFixMe) => {
    onChange({ keys: selectedValues, freeform: text });
  };

  const renderOtherResponse = () => {
    if (selectedValues.includes(OTHER_VALUE)) {
      return (
        <Other
          value={otherTextValue}
          onChange={handleOtherTextChange}
          handleEditResponse={handleEditResponse}
        />
      );
    }
  };

  const renderOther = () => {
    if (question.properties.hasOther) {
      return (
        <>
          <CheckboxOption
            label={otherOptionLabel}
            value={OTHER_VALUE}
            checked={selectedValues.includes(OTHER_VALUE)}
            onChange={handleCheckedInput}
            key={OTHER_VALUE}
          />
          {renderOtherResponse()}
        </>
      );
    }
  };

  return (
    <div className="question checkbox">
      <QuestionLabel question={question} />
      <div className="responses">
        <div className="input-wrapper">
          {question.properties.options.map((option: $TSFixMe) => {
            return (
              <CheckboxOption
                label={option.label}
                value={option.value}
                checked={selectedValues.includes(option.value)}
                onChange={handleCheckedInput}
                key={option.value}
              />
            );
          })}
          {renderOther()}
        </div>
      </div>
    </div>
  );
};

export default Checkbox;
